// extracted by mini-css-extract-plugin
module.exports = {"container":"button_container__qlbyz","primary":"button_primary__3Ajav","secondary":"button_secondary__2PH98","loadingIcon":"button_loadingIcon__2mXa0","spin":"button_spin__EwRSc"};